<template>
  <div class="layer">
    <div class="inner categoryInner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">마이콜렉션</h2>
      <div class="flexBox">
        <div class="flexInner" data-flex="2">
          <div class="label groupLabel mb15">기본 설정</div>
          <div class="mb15">
            <div class="label setLabel mb5">페이지 배경</div>
            <ColorPicker
              class="mt5"
              :target="'backgroundColor'"
              :color="backgroundColor"
              :useColorOnly="true"
              @changeColor="changeColor" />
          </div>
          <div class="mb15">
            <div class="label setLabel mb5">마이콜렉션 컬럼 수</div>
            <input type="text" class="input inlineInput" v-model="listColumn">
          </div>
          <div class="mb15" data-responsive="icon">
            <div class="label setLabel mb5">콜렉션 담기 아이콘</div>
            <div class="mb10">
              <label>기본</label>
              <div v-if="scrapIcon.default" class="bgThumb">
                <img :src="scrapIcon.default" alt="">
                <button type="button" class="delThumb" @click="deleteImage('default')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_icon_default" @change="uploadImage($event, 'default')">
                <label for="upload_icon_default" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <div class="mb10">
              <label>활성화</label>
              <div v-if="scrapIcon.active" class="bgThumb">
                <img :src="scrapIcon.active" alt="">
                <button type="button" class="delThumb" @click="deleteImage('active')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_icon_active" @change="uploadImage($event, 'active')">
                <label for="upload_icon_active" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <div class="mb10">
              <label>크기</label>
              <div class="iconSize">
                <div class="unitInput size120">
                  <input type="text" class="input" v-model="scrapIcon.size">
                  <span class="unit">px</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mb15">
            <div class="innerTitle setLabel">디스플레이</div>
            <span class="checkbox mr15"
              v-for="d in displays"
              :key=d>
              <input type="checkbox" name="display_mycollection_items" :id="`mycollection_items_${d}`" :value="d" v-model="display" />
              <label :for="`mycollection_items_${d}`">{{ locale[d] }}</label>
            </span>
          </div>
        </div>
        <div class="flexInner" data-flex="5">
          <div class="label groupLabel mb5">{{locale.category}}</div>
          <div class="addCategory">
            <button type="button" class="btn btnWhite btnFull btnAdd" @click="addCategory"></button>
          </div>
          <MyCollectionCategory
            :locale="locale"
            :list="category"
            :defaultLang="defaultLang"
            @removeItem="removeItem"
            @setLanguage="setLanguage" />
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
  
</template>

<script>
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import UTIL from '@/common/util'
import LangValue from '@/components/Util/LangValue'
import ColorPicker from '@/components/Util/ColorPicker'
import MyCollectionCategory from './MyCollectionCategory'

export default {
  name: 'MyCollection',
  props: [
    'locale',
    'defaultLang',
    'pageId'
  ],
  components: {
    ColorPicker,
    LangValue,
    MyCollectionCategory
  },
  computed: {
  },
  async created () {
    this.$store.commit('onLoading', true)
    await this.getMyCollection()
    this.$store.commit('onLoading', false)
  },
  data () {
    return {
      displays: [
        'image',
        'name',
        'descTop',
        'descBottom'
      ],
      myCollection: {
        backgroundColor: 'rgba(245,246,247,1)',
        column: '3'
      },
      backgroundColor: 'rgba(245,246,247,1)',
      listColumn: '3',
      scrapIcon: {
        default: '',
        active: '',
        size: '60'
      },
      category: [],
      display: [
        'image', 'name', 'descTop', 'descBottom'
      ],
      langTarget: null,
      langValueLayer: false,
      langValue: {}
    }
  },
  methods: {
    // 마이콜렉션 설정 호출
    async getMyCollection () {
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getMyCollection', this.pageId)
      const myCollection = res?.message?.myCollectionSetting
      if (myCollection) {
        this.backgroundColor = myCollection.backgroundColor,
        this.listColumn = myCollection.listColumn
        this.scrapIcon = myCollection.scrapIcon
        this.category = myCollection.category,
        this.display = myCollection.display
        this.$store.commit('collection/setMyCollectionCategory', myCollection.category)
      } else {
        alert(this.locale.system_error)
      }
      this.$store.commit('onLoading', false)
    },
    changeColor (data) {
      this[data.target] = data.color
    },
    uploadImage (e, target) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.scrapIcon[target] = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage (target) {
      if (window.confirm(this.locale.confirm_delete)) {
        this.scrapIcon[target] = ''
      }
    },
    addCategory () {
      this.category.push({
        categoryId: UNIQUE.uniqueId8(),
        categoryLabel: LANG.valueObj('')
      })
    },
    setLanguage (categoryId, categoryLabel) {
      const fillLangs = UTIL.fillLangs(categoryLabel, categoryLabel[this.defaultLang])
      categoryLabel = fillLangs
      this.langTarget = categoryId
      this.langValueLayer = true
      this.langValue = categoryLabel
    },
    closeLanguage () {
      const categoryId = this.langTarget
      const targetItem = findCategoryItem(this.list, categoryId)
      function findCategoryItem(array, categoryId) {
        for (const item of array) {
          if (item.categoryId === categoryId) {
            return item
          }
          if (item.subCategory && Array.isArray(item.subCategory)) {
            const found = findCategoryItem(item.subCategory, categoryId)
            if (found) {
              return found
            }
          }
        }
        return null
      }
      if (targetItem) {
        targetItem.categoryLabel = this.langValue
      }
      this.langTarget = null
      this.langValueLayer = false
      this.langValue = {}
    },
    removeItem (categoryId) {
      function removeCategoryById (data, targetId) {
        // 깊은 복사 (원본 보존)
        function recursiveFilter(arr) {
          return arr.map(item => {
            // 하위 카테고리가 있는 경우 재귀 처리
            if (item.subCategory) {
              item.subCategory = recursiveFilter(item.subCategory)
            }
            return item
          }).filter(item => item.categoryId !== targetId)
          // 현재 배열에서 targetId와 일치하는 항목 제거
        }
        return recursiveFilter(data)
      }
      const list = removeCategoryById(this.category, categoryId)
      this.category = list
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    async save () {
      const data = {
        pageId: this.pageId,
        myCollectionSetting: {
          backgroundColor: this.backgroundColor,
          listColumn: this.listColumn,
          scrapIcon: this.scrapIcon,
          category:this.category,
          display: this.display
        }
      }
      console.log(data)
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/putMyCollection', data)
      if (res?.status === 200) {
        alert(this.locale.complete_save)
        // await this.getCollectionNav()
        this.$emit('close')
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 800px;
  }
  .flexBox {
    overflow: auto;
  }
}
.addCategory {
  .btnAdd {
    background-color: $color-white;
  }
}
</style>
